export const isInIFrame = () => window.self !== window.top;
